<template lang="pug">
.mini
  .appTools
    .level
      .type(:title="levelName") 楼层：{{levelName}}
      i.el-icon-arrow-up(@click="selectMapOptions")
    //- .level
    //-   el-checkbox(v-model="checked",size="mini" @change="showRoom") 显示房间
    i.el-icon-minus.close(title="最小化",@click="closeAdd")
  transition(name="el-fade-in-linea")
    .mapLevelList(v-show="showLevel")
      .chil(:class="{'isActive': item.elevation == mapdata}",v-for="item in mapOptions",
        :key="item.id",:title="item.name" @click="setLevels(item)") {{item.name}}
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  data () {
    return {
      mapdata: "",
      mapOptions: [],
      levelName: '',
      checked: false,
      showLevel: false
    };
  },
  mounted () {
    this.init();
  },
  methods: {
    async init() {
      this.mapOptions = await mongeApiMlib.getLevels();
      this.mapdata = this.mapOptions[0].elevation;
      this.levelName = this.mapOptions[0].name;
      this.openMini(this.mapdata);
    },
    selectMapOptions() {
      this.showLevel = !this.showLevel;
    },
    openMini(val) {
      mongeApiMlib.changeMini(val, this.checked, {
        callback: (type) => {
          if (type === 3) {
            // this.$emit("closeCom",'modelMini',false)
          }
        }
      });
    },
    showRoom(flag) {
      mongeApiMlib.setNameShow(flag);
    },
    setLevels(item) {
      this.mapdata = item.elevation ;
      this.levelName = item.name;
      this.showLevel = false;
      mongeApiMlib.setMiniHeight(this.mapdata);
      // this.openMini(this.mapdata)
    },
    closeAdd() {
      this.$emit("closeCom", 'modelMini', true);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
.appTools{
  width: 210px;
  left: calc(50% - 110px);
}
.mapLevelList{
  position: absolute;
  width: 90px;
  height: 100px;
  overflow-x: hidden;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  // transition: all 0.3s ease 0s;
  left: calc(50% - 110px);
  bottom: 35px;
  padding: 5px 0;
  z-index: 4;
  .chil{
    padding: 0 14px;
    margin-top: 2px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
  }
  .isActive{
    background: rgba(56, 115, 254, 0.18);
  }
  .chil:hover{
    background: rgba(56, 115, 254, 0.18);
  }
}
.minimaplevel{
  width: 150px;
  position: absolute;
  left: 250px;
  bottom: 302px;
  z-index: 4;
  /deep/.el-select{
    background-color: rgba(0, 0, 0, 0.3) !important;
  }
}
</style>
